module.exports = __webpack_public_path__ + "static/media/zara.fa3b054f.png";